import { render, staticRenderFns } from "./JobWorkerInterviewStatus.vue?vue&type=template&id=5a25de1f&"
import script from "./JobWorkerInterviewStatus.vue?vue&type=script&lang=ts&"
export * from "./JobWorkerInterviewStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
